import type { Cart, CartLight } from '@maestro/data-layer'

import { buildPrice } from '@maestro/commerce-blocks/utils/price.utils'
import { theme } from '@maestro/local/theme'

export const emptyCartStructure: Cart = {
  cartId: '',
  cartVersion: 0,
  ttl: 0,
  totalQuantity: 0,
  entries: [],
  couponCodes: [],
  priceSummary: {
    grandTotal: buildPrice(theme().priceConfig.currencyIso, 0),
    subTotal: buildPrice(theme().priceConfig.currencyIso, 0),
    totalTax: buildPrice(theme().priceConfig.currencyIso, 0),
    totalDiscounts: buildPrice(theme().priceConfig.currencyIso, 0),
    deliveryCost: undefined,
  },
  freeShippingBar: {
    amountLeft: undefined,
    amountThreshold: undefined,
    deliveryFrom: undefined,
    progress: 0,
  },
}

export const emptyCartLightStructure: CartLight = {
  cartId: '',
  cartVersion: 0,
  ttl: 0,
  totalQuantity: 0,
  priceSummary: {
    grandTotal: buildPrice(theme().priceConfig.currencyIso, 0),
    subTotal: buildPrice(theme().priceConfig.currencyIso, 0),
    totalTax: buildPrice(theme().priceConfig.currencyIso, 0),
    totalDiscounts: buildPrice(theme().priceConfig.currencyIso, 0),
    deliveryCost: undefined,
  },
}
